import { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { setToken } from 'redux/reducers/token'
import { toast } from 'react-toastify'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { verifySignature } from 'services/apiAuth'

export default ({ location, history }) => {
  const { pathname } = location
  const params = new URLSearchParams(location.search)
  const dispatch = useDispatch()

  if (!params.has('signature')) {
    history.replace({
      pathname: '/forbidden',
      state: { error: 'Link inválido!' },
    })
    return null
  }

  const verifySig = useCallback(
    async (signature) => {
      try {
        const res = await verifySignature({ signature: signature })
        const { data, status } = res

        if (status === 200 && data) {
          const { access_token } = data

          dispatch(setToken(access_token))

          if (pathname === ROUTE_CONSTANTS.ACCOUNT_CREATION) {
            history.replace({
              pathname: ROUTE_CONSTANTS.PASSWORD_CREATION,
            })
          } else {
            history.replace({
              pathname: ROUTE_CONSTANTS.PASSWORD_REDEFINE,
            })
          }
        } else {
          toast.error(
            'Assinatura inválida ou expirada, em instantes você será redirecionado ao login',
          )
        }
      } catch (e) {
        let state = {}
        if (e.response) {
          state = {
            error: e.response.data.detail,
            redirect: e.response.data.redirect_url,
          }
        } else {
          state = {
            error: 'Houve um problema na requisicao',
          }
        }

        history.replace({
          pathname: '/forbidden',
          state: state,
        })
      }
      return null
    },
    [dispatch, history],
  )

  useEffect(() => {
    verifySig(params.get('signature'))
  }, [params.signature, verifySig])

  return null
}
